import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'SYNCHRONISATION' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/synchronisation/handlers.js